import CallTypeComponent from "../../Components/Masters/CallType/CallTypeComponent"

const CallTypePage = () =>{
    return(
        <CallTypeComponent/>
    )
}

export default CallTypePage